<ng-container *transloco="let tRecordSettings; read: 'record_settings'">
    <app-modal-layout
        [containerLayout]="containerLayout"
        (closeModal)="forceWithValidation()"
        class="w-[31.25rem] block"
    >
        <ng-container title>
            <div>{{ tRecordSettings('record_settings') }}</div>
        </ng-container>
        <ng-container [formGroup]="settingsFormGroup">
            <div class="my-6 flex flex-col">
                <div class="mb-1 body-1 flex items-center gap-1">
                    <span>{{ tRecordSettings('workspace') }}</span>
                    <app-tb-tooltip-component
                        class="icon-sm"
                        [tooltipClass]="['w-[21rem]', 'h-[4.25rem]', 'tooltip-align']"
                        [tooltip]="tRecordSettings('workspace_tooltip')"
                    >
                        <app-tb-icon icon="info" color="textLight"></app-tb-icon>
                    </app-tb-tooltip-component>
                </div>
                <app-tb-select [shaded]="true" [multiple]="true" formControlName="workspace">
                    <app-tb-option
                        [disabled]="true"
                        [icon]="globalWorkspace.icon.value"
                        [iconColor]="globalWorkspace.color.value"
                        [value]="globalWorkspace.guid"
                        [divideAfter]="true"
                        >{{ globalWorkspace.name.value }}</app-tb-option
                    >

                    @for (workspace of availableWorkspaces; track workspace.guid) {
                        <app-tb-option
                            [value]="workspace.guid"
                            [icon]="workspace.icon.value"
                            [iconColor]="workspace.color.value"
                        >
                            {{ workspace.name.value }}
                        </app-tb-option>
                    }
                </app-tb-select>
                <div class="mt-1 caption-1 text-textLight">
                    {{ tRecordSettings('select_description') }}
                </div>
            </div>
            <div *transloco="let tSchemaReadableName; read: 'nav_menu'">
                <div class="mb-1 body-1">{{ tRecordSettings('type') }}</div>
                <app-tb-select formControlName="schema" tagIconColor="primary">
                    @for (schema of data.schemas; track schema.guid) {
                        <app-tb-option
                            [icon]="schemaIconByName[schema.name]"
                            [value]="schema.guid"
                            [active]="schema.guid === settingsFormGroup.value.schema"
                            iconColor="primary"
                        >
                            {{ tSchemaReadableName(schema.name) }}
                        </app-tb-option>
                    }
                </app-tb-select>
            </div>
            <div *appEnv="'prod'; visible: false" class="mt-6">
                <div class="mb-1 text-text">{{ tRecordSettings('template') }}</div>
                <app-tb-select>
                    <app-tb-option value="values">$Values here</app-tb-option>
                    <app-tb-option>$Values here</app-tb-option>
                    <app-tb-option>$Values here</app-tb-option>
                </app-tb-select>
            </div>
            <app-access-selector *appEnv="'prod'; visible: false"></app-access-selector>
        </ng-container>
        <app-modal-layout-buttons
            *transloco="let tButtons; read: 'buttons'"
            buttons
            [action]="true"
            [primary]="true"
        >
            <app-tb-button
                action
                appearance="text"
                icon="custom_arrow_back"
                (click)="cancelSettingsChange()"
            >
                {{ tButtons('back') }}
            </app-tb-button>

            <app-tb-button primary (click)="applySettingsChange()">
                {{ tButtons('apply') }}
            </app-tb-button>
        </app-modal-layout-buttons>
    </app-modal-layout>
</ng-container>
